import { nanoid } from "nanoid"
import { groupDiffs } from "@/components/tiptap/customExtensions/aiChange/diff"

// parseMarkdownToHTML 함수를 import하거나 여기에 복사
function parseMarkdownToHTML(markdown: string): string {
  const lines = markdown.split('\n');
  const htmlParts: string[] = [];
  
  for (let line of lines) {
    line = line.trim();
    
    if (!line) {
      continue;
    }
    
    if (/^(-{3,}|\*{3,}|_{3,})$/.test(line)) {
      htmlParts.push('<hr>');
      continue;
    }
    
    if (line.startsWith('### ')) {
      const text = line.substring(4).trim();
      htmlParts.push(`<h3>${text}</h3>`);
    } else if (line.startsWith('## ')) {
      const text = line.substring(3).trim();
      htmlParts.push(`<h2>${text}</h2>`);
    } else if (line.startsWith('# ')) {
      const text = line.substring(2).trim();
      htmlParts.push(`<h1>${text}</h1>`);
    } 
    else if (line.startsWith('- ') || line.startsWith('* ') || line.startsWith('+ ')) {
      const text = line.substring(2).trim();
      const processedText = text
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.*?)\*/g, '<em>$1</em>')
        .replace(/`(.*?)`/g, '<code>$1</code>');
      htmlParts.push(`<ul><li>${processedText}</li></ul>`);
    }
    else if (/^\d+\.\s/.test(line)) {
      const text = line.replace(/^\d+\.\s/, '').trim();
      const processedText = text
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.*?)\*/g, '<em>$1</em>')
        .replace(/`(.*?)`/g, '<code>$1</code>');
      htmlParts.push(`<ol><li>${processedText}</li></ol>`);
    }
    else {
      const processedText = line
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.*?)\*/g, '<em>$1</em>')
        .replace(/`(.*?)`/g, '<code>$1</code>');
      
      htmlParts.push(`<p>${processedText}</p>`);
    }
  }
  
  return htmlParts.join('');
}

export function applyDiffToEditor({
  editor,
  original,
  updated,
  action, // action 파라미터 추가
}: {
  editor: any
  original: string
  updated: string
  action?: string // 옵셔널로 추가
}) {
  // enrich의 경우 마크다운을 HTML로 변환 후 처리
  if (action === "enrich") {
    try {
      const htmlContent = parseMarkdownToHTML(updated);
      const { from, to } = editor.state.selection
      
      if (from !== to) {
        editor.commands.deleteRange({ from, to })
      }
      
      editor.commands.insertContent(htmlContent);
      return;
    } catch (error) {
      console.error("Markdown parsing failed:", error);
      // 실패 시 일반 diff 처리로 폴백
    }
  }

  // 기존 diff 처리 로직
  const grouped = groupDiffs(original, updated)
  console.log("Grouped diffs:", grouped)

  const { from, to } = editor.state.selection
  
  if (from !== to) {
    editor.commands.deleteRange({ from, to })
  }

  const schema = editor.schema
  const tr = editor.state.tr
  let pos = from

  for (const block of grouped) {
    if (block.type === "unchanged") {
      const textNode = schema.text(block.text)
      tr.insert(pos, textNode)
      pos += block.text.length
      continue
    }

    const diffId = nanoid()

    if (block.type === "insert") {
      const mark = schema.marks.diffAdded?.create({ diffId })
      const textNode = schema.text(block.text, mark ? [mark] : [])
      tr.insert(pos, textNode)
      pos += block.text.length
      
    } else if (block.type === "delete") {
      const mark = schema.marks.diffRemoved?.create({ diffId })
      const textNode = schema.text(block.text, mark ? [mark] : [])
      tr.insert(pos, textNode)
      pos += block.text.length
      
    } else if (block.type === "change") {
      const removedMark = schema.marks.diffRemoved?.create({ diffId })
      const removedNode = schema.text(block.removed, removedMark ? [removedMark] : [])
      tr.insert(pos, removedNode)
      pos += block.removed.length
      
      const addedMark = schema.marks.diffAdded?.create({ diffId })
      const addedNode = schema.text(block.added, addedMark ? [addedMark] : [])
      tr.insert(pos, addedNode)
      pos += block.added.length
    }
  }

  editor.view.dispatch(tr)
}